import React from 'react';
import {
  IonButtons,
  IonFooter,
  IonButton,
  IonModal,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
} from '@ionic/react';
import intl, { Text } from '$gintl';

interface ModalProps {
  show: boolean;
  title?: string;
  titleText?: string;
  className?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  useCustom?: boolean;
  onClose: () => void;
}

const Modal: React.FC<ModalProps> = ({
  show,
  title = '',
  titleText,
  children,
  className,
  footer,
  useCustom,
  onClose,
}) => {
  return (
    <IonModal isOpen={show} cssClass={className} swipeToClose={true} onDidDismiss={onClose}>
      <>
        {(title || titleText) && (
          <IonHeader>
            <IonToolbar>
              <IonTitle>{titleText || intl(title)}</IonTitle>
              <IonButtons slot="end">
                <IonButton onClick={onClose}>
                  <Text k="BUTTON.CLOSE" />
                </IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
        )}
        {useCustom && <>{children}</>}
        {!useCustom && <IonContent fullscreen>{children}</IonContent>}
        {footer && (
          <IonFooter>
            <IonToolbar>{footer}</IonToolbar>
          </IonFooter>
        )}
      </>
    </IonModal>
  );
};

export default Modal;
